import React, {useEffect, memo} from 'react';
import {useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {
  CardCvcElement,
  CardElementProps,
  CardExpiryElement,
  CardNumberElement,
  PaymentElement,
  useElements,
} from '@stripe/react-stripe-js';
import {StripeElementLocale} from '@stripe/stripe-js';
import {FormTypes} from './PaymentFormV2';
import {FieldsColumn} from './styled';

type StripePaymentFormProps = {
  splitCardElementsProps?: CardElementProps | null;
  onConfirm: () => void;
  onFormReady?: () => void;
  onFormComplete?: (state: boolean) => void;
  disabledFields?: boolean;
};
const StripePaymentForm = memo(function StripePaymentForm(_: StripePaymentFormProps) {
  const {i18n} = useTranslation();
  const {reset} = useFormContext<FormTypes>();
  const elements = useElements();

  useEffect(
    function clearStripeFormWhenChangedLanguage() {
      elements?.getElement(CardNumberElement)?.clear();
      elements?.getElement(CardExpiryElement)?.clear();
      elements?.getElement(CardCvcElement)?.clear();
      reset();
    },
    [elements, i18n.language, reset],
  );

  useEffect(() => {
    const newLocale = i18n.language as StripeElementLocale;
    elements?.update({locale: newLocale});
  }, [elements, i18n.language]);

  return (
    <FieldsColumn>
      <PaymentElement />
    </FieldsColumn>
  );
});

export {StripePaymentForm};
